var components = {
  uCellGroup: function () {
    return import(
      /* webpackChunkName: "node-modules/uview-ui/components/u-cell-group/u-cell-group" */ "uview-ui/components/u-cell-group/u-cell-group.vue"
    )
  },
  uCellItem: function () {
    return import(
      /* webpackChunkName: "node-modules/uview-ui/components/u-cell-item/u-cell-item" */ "uview-ui/components/u-cell-item/u-cell-item.vue"
    )
  },
  uActionSheet: function () {
    return import(
      /* webpackChunkName: "node-modules/uview-ui/components/u-action-sheet/u-action-sheet" */ "uview-ui/components/u-action-sheet/u-action-sheet.vue"
    )
  },
  uPopup: function () {
    return import(
      /* webpackChunkName: "node-modules/uview-ui/components/u-popup/u-popup" */ "uview-ui/components/u-popup/u-popup.vue"
    )
  },
  uCheckbox: function () {
    return import(
      /* webpackChunkName: "node-modules/uview-ui/components/u-checkbox/u-checkbox" */ "uview-ui/components/u-checkbox/u-checkbox.vue"
    )
  },
}
var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
}
var recyclableRender = false
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns, recyclableRender, components }